import styled, { css } from 'styled-components';
import { Meta } from '@xingternal/typography';
import { xdlColorError, xdlColorTextSecondary } from '@xingternal/tokens';
const CharacterCounter = styled(Meta) `
  ${({ $maxCountReached }) => $maxCountReached
    ? css `
          color: ${xdlColorError};
        `
    : css `
          color: ${xdlColorTextSecondary};
        `};
`;
export const Styled = {
    CharacterCounter,
};
//# sourceMappingURL=character-counter.styles.js.map